export const SET_SHOPS = 'SET_SHOPS'
export const SET_SHOP = 'SET_SHOP'
export const ADD_SHOP = 'ADD_SHOP'
export const UPDATE_SHOP = 'UPDATE_SHOP'
export const DELETE_SHOP = 'DELETE_SHOP'
export const SET_LOADING = 'SET_LOADING'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_AVAILABLE_STORES = 'SET_AVAILABLE_STORES'
export const SET_CURRENT_SHOP = 'SET_CURRENT_SHOP'
